<div [ngSwitch]="getFormat(data?.format)" class="c-field-value" [ngClass]="customClass">
  <gtd-ui-field-default-money
    [data]="data?.value"
    customClass="w100 d-flex justify-content-end"
    *ngSwitchCase="'money'"
  ></gtd-ui-field-default-money>
  <ng-container *ngSwitchDefault> {{ data?.value | number }}%</ng-container>
</div>
